import { isValidElement } from 'react';
import { ToastOptions, toast } from 'react-hot-toast/headless';
import { Trans } from 'react-i18next';
import { IToastProps, Toast } from '@/common/components/Toast/Toast';

export const notify = ({
  message,
  type,
  closable,
  onClose = () => {},
  ...opts
}: IToastProps & ToastOptions) => {
  const finalMessage = isValidElement(message) ? (
    message
  ) : (
    <Trans i18nKey={message as string} />
  );

  return toast.custom(
    ({ id, visible }: { id: string; visible: boolean }) => {
      return (
        <Toast
          type={type}
          message={finalMessage}
          closable={closable}
          onClose={() => {
            onClose();
            toast.dismiss(id);
          }}
          removing={!visible}
        />
      );
    },

    { ...opts, duration: closable ? Infinity : 4000, removeDelay: 280 }
  );
};
